export default {
  default: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/layouts/default.vue").then(m => m.default || m),
  fundraising: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/layouts/fundraising.vue").then(m => m.default || m),
  peer: () => import("/home/runner/work/fundeasy/fundeasy/apps/public-pages/layouts/peer.vue").then(m => m.default || m)
}